import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'

const initialState = {
  userNotifications: []
}

const notificationsReducer = createReducer(initialState, {
  [ACT.NOTIFICATIONS_FETCH_SUCCESS](state, action) {
    const { userNotifications } = action.payload
    return {
      ...state,
      userNotifications
    }
  },
  [ACT.MARKREAD_FETCH_SUCCESS](state, action) {
    const { userNotifications } = action.payload
    return {
      ...state,
      userNotifications
    }
  },
  [ACT.MARKUNREAD_FETCH_SUCCESS](state, action) {
    const { userNotifications } = action.payload
    return {
      ...state,
      userNotifications
    }
  },
  [ACT.MARKALLREAD_FETCH_SUCCESS](state, action) {
    const { userNotifications } = action.payload
    return {
      ...state,
      userNotifications
    }
  }
})

export default notificationsReducer
